// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitDestination__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitDestination/SearchUnitDestination.scss
 ** module id = 937
 ** module chunks = 1
 **/